module.exports = __webpack_public_path__ + "img/messages.0bc076d4.svg";